export default {
  SET_USER_TYPES(state, usertypes) {
    state.usertypes = usertypes
  },
  REMOVE_USER_TYPE(state, itemId) {
      const usertypeIndex = state.usertypes.datas.findIndex((u) => u.id == itemId)
      state.usertypes.datas.splice(usertypeIndex, 1)
  },
  SELECTED_USER_TYPE(state,data){
    state.usertypes.datas = []
    state.usertypes.total = 1;
    state.usertypes.per_page = 1;
    state.usertypes.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
